import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getFeaturedArticles, getPopularArticles } from "@/mocks/articles";
import { categoryMap } from "@/mocks/categories";

export default function FeaturedArticles() {
  const { t } = useTranslation("home");
  const featured = getFeaturedArticles().slice(0, 4);
  const popular = getPopularArticles().slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            {t("featuredTitle")}
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            {t("featuredSubtitle")}
          </p>
        </div>

        <div className="mb-14">
          <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-6 flex items-center gap-2">
            <i className="ri-star-line text-accent-500"></i>
            {t("popularArticles")}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {featured.map((article) => {
              const cat = categoryMap[article.category];
              return (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-50/80"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-block px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
                        {cat?.name || "穿搭"}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h4>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.date}</span>
                      <span>{article.readingTime} 分钟阅读</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-6">
            <h3 className="font-heading text-lg font-semibold text-foreground-800 flex items-center gap-2">
              <i className="ri-fire-line text-accent-500"></i>
              {t("latestArticles")}
            </h3>
            <Link
              to="/category/chuanda-gonglue"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
            >
              {t("viewAll")}
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {popular.map((article) => {
              const cat = categoryMap[article.category];
              return (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-50/80"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-block px-2.5 py-1 bg-secondary-500 text-background-50 text-xs font-medium rounded-md">
                        {cat?.name || "穿搭"}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h4>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.date}</span>
                      <span>{article.readingTime} 分钟阅读</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}